// extracted by mini-css-extract-plugin
module.exports = {"container":"Page_container__A6MXE","children":"Page_children__VNcgH","green":"Page_green___PkbW","cyan":"Page_cyan__0_IBq","messageBarContainer":"Page_messageBarContainer__kV9c3"};